var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5415 0.516834C22.1042 7.29703 22.667 14.0768 23.2301 20.857C23.9109 19.7467 25.1833 18.9811 26.4937 18.9811C28.0572 18.9811 29.3197 19.9267 29.9084 21.2459C32.3455 17.5208 35.4721 13.8866 39.271 10.5412C39.0656 10.6592 38.8681 10.7946 38.6539 10.8928C37.4416 11.4457 36.2613 12.0967 35.0037 12.5168C31.2181 13.7808 27.881 12.7264 25.4154 9.57663C23.646 7.31796 22.6704 4.69439 21.9631 1.95248C21.8386 1.46962 21.7268 0.984097 21.6092 0.500095C21.5868 0.505804 21.5639 0.511127 21.5415 0.516834Z",
    fill: "url(#paint0_linear_644_1976)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8506 7.30776C26.8453 9.27801 28.3662 10.8171 30.3262 10.8244C32.2869 10.8316 33.8211 9.3347 33.831 7.40479C33.8409 5.39459 32.3375 3.85774 30.3467 3.84404C30.3387 3.84404 30.3311 3.84404 30.3235 3.84404C28.4343 3.84404 26.8556 5.41552 26.8506 7.30776Z",
    fill: "url(#paint1_linear_644_1976)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2413 29.1568V30.6133C33.7058 29.9018 36.1707 29.8303 38.6904 31.0684C39.9518 31.6886 41.3482 32.0315 42.6834 32.5002C42.6861 32.4675 42.6891 32.4348 42.6921 32.4021C42.0856 32.0052 41.4391 31.6574 40.8806 31.2016C39.6999 30.2382 39.459 28.9696 40.2668 27.685C40.6941 27.0065 41.3025 26.4403 41.8455 25.8384C41.9353 25.7391 42.1282 25.6379 42.2641 25.5804C42.2005 25.5089 42.1199 25.5157 42.0563 25.4442C38.0272 25.7326 34.3089 26.7166 31.2413 29.1568Z",
    fill: "url(#paint2_linear_644_1976)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36802 27.7543C7.12256 28.9651 6.89236 30.177 5.80982 31.1126C5.34295 31.5156 4.78132 31.8086 4.25889 32.1464C4.13332 32.2279 3.99368 32.2872 3.8605 32.3569C3.88105 32.3976 3.90198 32.4383 3.92291 32.479C4.98794 32.119 6.0541 31.7606 7.11799 31.3972C8.31201 30.9897 9.47674 30.4296 10.7039 30.199C12.2205 29.914 13.6897 30.1195 15.1257 30.5327V28.9369C12.0843 26.6661 8.45698 25.7156 4.52828 25.4458C5.17514 26.2448 5.86271 26.9427 6.36802 27.7543Z",
    fill: "url(#paint3_linear_644_1976)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7213 4.79686C12.1932 4.80028 10.9155 6.09666 10.922 7.63732C10.9284 9.16352 12.1913 10.4112 13.7202 10.4017C15.3153 10.3922 16.5405 9.17836 16.5367 7.61144C16.5325 6.06279 15.2681 4.79686 13.727 4.79686C13.7251 4.79686 13.7228 4.79686 13.7213 4.79686Z",
    fill: "#253EE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40502 18.4564C2.41758 19.7673 3.48793 20.8232 4.80409 20.8235C6.19255 20.8243 7.25377 19.7802 7.25682 18.4108C7.25986 17.0938 6.16287 16.0022 4.83568 16.0003C4.83416 15.9999 4.83301 15.9999 4.83187 15.9999C3.48184 16.0003 2.39208 17.1026 2.40502 18.4564Z",
    fill: "#D91E77"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3508 18.4245C39.3413 19.7513 40.4127 20.8175 41.7654 20.827C43.1109 20.8365 44.2045 19.7688 44.2056 18.4446C44.206 17.114 43.1345 16.0204 41.8096 15.9999C41.797 15.9999 41.7841 15.9999 41.7715 15.9999C40.4402 15.9999 39.3603 17.0775 39.3508 18.4245Z",
    fill: "url(#paint4_linear_644_1976)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47772 28.7471C2.47239 29.6573 3.20601 30.3959 4.11883 30.4004C5.04003 30.405 5.77098 29.6775 5.76831 28.7597C5.76565 27.8724 5.04688 27.1475 4.1565 27.133C4.14699 27.1327 4.13786 27.1327 4.12873 27.1327C3.22123 27.1327 2.48267 27.8514 2.47772 28.7471Z",
    fill: "url(#paint5_linear_644_1976)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4856 27.1345C41.5313 27.1349 40.8262 27.8582 40.8392 28.8239C40.851 29.7048 41.5891 30.4087 42.4932 30.4008C43.4167 30.3931 44.1305 29.6614 44.1164 28.7383C44.1027 27.8438 43.3817 27.1345 42.486 27.1345H42.4856Z",
    fill: "#D91E77"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3037 28.1371C18.5776 25.3956 18.8459 22.7073 19.1214 19.9506C20.1712 20.3151 21.1004 20.8231 21.8827 21.5924C22.2849 21.9878 22.6779 22.4417 22.9329 22.9524C23.1756 23.4398 23.3438 24.033 23.3541 24.5836C23.3982 26.9838 23.3731 29.3852 23.3731 31.9501C22.2491 29.6686 20.479 28.6131 18.3037 28.1371Z",
    fill: "#2C57E9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.327 29.2335C19.5553 29.5577 21.7036 29.91 22.7831 32.3932C21.0278 30.1593 18.7262 30.0287 16.2651 30.4153C16.2533 30.3096 16.2274 30.2137 16.2346 30.1204C16.4138 27.7282 16.5934 25.336 16.786 22.9449C16.7978 22.8003 16.8838 22.6196 16.9892 22.5355C17.2513 22.3262 17.5451 22.1634 17.9336 21.9126C17.7266 24.4098 17.5287 26.7998 17.327 29.2335Z",
    fill: "#2C57E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1605 21.5212C24.7583 21.9169 24.3652 22.3705 24.1103 22.8815C23.8672 23.3689 23.6994 23.9621 23.6891 24.5127C23.6449 26.9129 23.6704 29.3143 23.6704 31.8793C24.7941 29.5978 26.5646 28.5423 28.7391 28.0659C28.4655 25.3247 28.1973 22.6365 27.9218 19.8797C26.872 20.2439 25.9428 20.7522 25.1605 21.5212Z",
    fill: "#F3921A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7129 29.1628C27.4847 29.487 25.3364 29.8393 24.2569 32.3225C26.0121 30.0886 28.3134 29.9581 30.7749 30.3443C30.7863 30.2389 30.8126 30.1426 30.8053 30.0494C30.6261 27.6575 30.4465 25.2653 30.254 22.8742C30.2422 22.7296 30.1562 22.5489 30.0504 22.4648C29.7886 22.2555 29.4949 22.0931 29.1064 21.8415C29.3134 24.3392 29.5112 26.7287 29.7129 29.1628Z",
    fill: "#F3921A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.627 9.12335C17.7831 10.9349 16.5156 12.2652 14.4571 12.6023C12.9933 12.842 11.5839 12.5197 10.24 11.9585C9.23809 11.5403 8.27237 11.0335 7.3371 10.5879C8.62891 11.8531 10.0033 13.1023 11.262 14.4588C12.4457 15.7342 13.5796 17.0648 14.6371 18.4468L16.5354 21.2987C16.5354 21.2987 17.6362 17.9982 21.1418 19.8832C20.7274 14.6467 20.3134 9.84631 19.8994 4.5535C19.6331 6.14096 19.3005 7.67744 18.627 9.12335Z",
    fill: "url(#paint6_linear_644_1976)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66033 13.8088C7.71319 15.2167 8.69983 16.6645 9.07006 18.4289C9.37979 19.906 8.87068 21.0665 7.60474 21.7103C7.20635 21.9132 6.77791 22.1266 6.34452 22.178C5.05803 22.3306 3.76356 22.4459 2.46909 22.4949C1.66128 22.5254 0.847762 22.4097 0.0369089 22.3595C0.0243523 22.396 0.0121761 22.4322 0 22.4687C0.186447 22.5855 0.367563 22.7126 0.560479 22.8184C2.92607 24.1155 5.49675 24.582 8.15533 24.7704C9.30445 24.8518 10.473 25.0234 11.5723 25.3541C12.8492 25.7384 14.0238 26.3251 15.1284 27.0344L15.5097 27.1808L16.0059 22.7556L15.1284 21.815C14.6977 21.1697 14.2502 20.5331 13.7826 19.9079C11.9543 17.4651 9.86798 15.2707 7.38253 13.4808C6.7897 13.0543 6.16378 12.6734 5.55307 12.2712C5.87611 12.8473 6.28858 13.3126 6.66033 13.8088Z",
    fill: "url(#paint7_linear_644_1976)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3462 22.0111L31.3458 22.0089L30.8074 22.6881L30.9779 27.3789L31.2404 27.2115V27.2153C31.3363 27.151 31.4337 27.089 31.5304 27.0266L31.7366 26.8945C33.8758 25.559 36.2071 24.7515 38.8337 24.7161C40.9965 24.6868 43.1007 24.1914 45.0877 23.2953C45.612 23.0587 46.1101 22.763 46.6207 22.494C46.4035 22.3787 46.2368 22.3715 46.0709 22.3799C45.0318 22.4308 43.9918 22.5431 42.9546 22.5237C41.6186 22.4978 40.2831 22.3783 39.0575 21.7505C37.8935 21.1539 37.3308 20.2098 37.4746 18.9116C37.5404 18.3165 37.7029 17.7149 37.9259 17.1578C38.6051 15.4612 39.718 14.0381 40.8847 12.6546C40.9642 12.5602 41.0289 12.454 41.1008 12.3536C36.9468 14.8786 33.8381 18.208 31.3462 22.0111Z",
    fill: "url(#paint8_linear_644_1976)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_644_1976",
    x1: 21.5415,
    y1: 10.8729,
    x2: 39.271,
    y2: 10.8729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2631C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_644_1976",
    x1: 26.8506,
    y1: 7.33421,
    x2: 33.8309,
    y2: 7.33421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2631C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_644_1976",
    x1: 31.2412,
    y1: 28.9724,
    x2: 42.6922,
    y2: 28.9724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E21174"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_644_1976",
    x1: 3.86033,
    y1: 28.9625,
    x2: 15.1257,
    y2: 28.9625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2631C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_644_1976",
    x1: 39.3507,
    y1: 18.4133,
    x2: 44.2053,
    y2: 18.4133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3050F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_644_1976",
    x1: 2.47763,
    y1: 28.7666,
    x2: 5.76824,
    y2: 28.7666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2631C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_644_1976",
    x1: 7.33687,
    y1: 12.9262,
    x2: 21.1417,
    y2: 12.9262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2970FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D56E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_644_1976",
    x1: -0.000232107,
    y1: 19.7259,
    x2: 16.0057,
    y2: 19.7259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC0C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2485"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_644_1976",
    x1: 30.8076,
    y1: 19.8661,
    x2: 46.6206,
    y2: 19.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B5DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C59EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/LOGO.5bb4928a536ff28f6c16c63ac4408a62.svg";
export { ForwardRef as ReactComponent };